import * as tslib_1 from "tslib";
import { VuexModule, Module, Action, Mutation, getModule, } from "vuex-module-decorators";
import { getPermission, requestLogout } from "@/api/users";
import store from "@/store";
const getToken = () => window.localStorage.getItem("token");
const setToken = (token) => window.localStorage.setItem("token", token);
const getSSOUserId = () => window.localStorage.getItem("ssoUserId");
const setSSOUserId = (id) => window.localStorage.setItem("ssoUserId", id);
const getEmail = () => window.localStorage.getItem("email");
const setEmail = (email) => window.localStorage.setItem("email", email);
// const getPermissions = () => window.localStorage.getItem("permissionList");
// const setPermissions = (permissions: string) =>
//   window.localStorage.setItem("permissionList", permissions);
const clear = () => window.localStorage.clear();
const LoginUrl = {
    online: "https://sso.zuowenzhitiao.com",
    production: "https://sso.zuowenzhitiao.com",
    grey: "https://sso-gray.zuowenzhitiao.com",
    test: "http://sso-test.zuowenzhitiao.com",
    dev: "http://sso-dev.zuowenzhitiao.com",
    k8s: "http://sso-test2.zuowenzhitiao.com",
};
/**
 * 跳转登录界面
 */
export const redirectLogin = () => {
    const COURSE_ADMIN_ENV = process.env.COURSE_ADMIN_ENV;
    const url = LoginUrl[COURSE_ADMIN_ENV || "dev"];
    window.location.href = `${url}/#/?menuCode=zwzt-course-system&redirect=${encodeURIComponent(`${window.location.href}`)}`;
};
/**
 * 转换为权限列表
 * @param src 源对象
 * @returns 权限列表
 */
const generatePermissionList = (src) => {
    if (!src || typeof src != "object")
        return [];
    const res = [];
    if (src.hasOwnProperty("code") && src.code) {
        if (src.hasOwnProperty("subMenu") && src.subMenu) {
            src.subMenu.forEach((c) => {
                res.push(...generatePermissionList(c));
            });
        }
        res.push(src.code);
    }
    return res;
};
let User = class User extends VuexModule {
    constructor() {
        super(...arguments);
        // --------------------State--------------------
        this._token = getToken() || "";
        this._ssoId = getSSOUserId() || "";
        this._email = getEmail() || "";
        this._permissions = []; // 权限列表
    }
    // --------------------Getters--------------------
    get token() {
        return this._token;
    }
    get ssoId() {
        return this._ssoId;
    }
    get email() {
        return this._email;
    }
    get permissions() {
        return this._permissions;
    }
    // --------------------Mutation--------------------
    SET_TOKEN(token) {
        this._token = token;
    }
    SET_SSOID(ssoId) {
        this._ssoId = ssoId;
    }
    SET_EMAIL(email) {
        this._email = email;
    }
    SET_PERMISSION(permissions) {
        this._permissions = permissions;
    }
    // --------------------Action--------------------
    setAuth(data) {
        if (data.token) {
            setToken(data.token);
            this.context.commit("SET_TOKEN", data.token);
        }
        if (data.ssoUserId) {
            setSSOUserId(data.ssoUserId);
            this.context.commit("SET_SSOID", data.ssoUserId);
        }
        if (data.email) {
            setEmail(data.email);
            this.context.commit("SET_EMAIL", data.email);
        }
    }
    clearAuth() {
        this.context.commit("SET_TOKEN", "");
        this.context.commit("SET_SSOID", "");
        this.context.commit("SET_EMAIL", "");
        clear();
    }
    async authorize() {
        const res = await getPermission(this.ssoId);
        if (res.data.status !== 200)
            return false; // 获取授权失败
        // 请求API得到权限信息 解析为权限列表
        const permissions = generatePermissionList(res.data.data);
        if (permissions.length === 0)
            return false; // 解析结果为空也视为获取授权失败
        this.context.commit("SET_PERMISSION", permissions);
        return true;
    }
    async logout() {
        try {
            const res = await requestLogout();
            if (res.data.code !== 200)
                return;
            this.clearAuth(); // 登出成功后清除token信息
            window.location.href = "/"; // 清除hash后再重定向到登录界面
        }
        catch {
            // [TIPS] Axios守卫已对请求失败做处理 此处无须处理
            // 但须保留catch 以捕获异常
        }
    }
};
tslib_1.__decorate([
    Mutation
], User.prototype, "SET_TOKEN", null);
tslib_1.__decorate([
    Mutation
], User.prototype, "SET_SSOID", null);
tslib_1.__decorate([
    Mutation
], User.prototype, "SET_EMAIL", null);
tslib_1.__decorate([
    Mutation
], User.prototype, "SET_PERMISSION", null);
tslib_1.__decorate([
    Action // 设置token信息
], User.prototype, "setAuth", null);
tslib_1.__decorate([
    Action // 清除当前token信息
], User.prototype, "clearAuth", null);
tslib_1.__decorate([
    Action
], User.prototype, "authorize", null);
tslib_1.__decorate([
    Action
], User.prototype, "logout", null);
User = tslib_1.__decorate([
    Module({ dynamic: true, store, name: "user" })
], User);
export const UserModule = getModule(User);
